<template>
  <section class="section pt-3">
    <div class="buttons is-pulled-right">
      <div class="button is-info is-rounded" @click="human_tasks">
        <span class="icon">
          <i class="fa fa-user-circle"></i>
        </span>
        <span>{{ $t("human tasks") }}</span>
      </div>
      <div class="button is-primary is-rounded" @click="save">
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </div>
    </div>
    <div class="title is-4">{{ process.name }}</div>
    <div ref="process_container" class="editor-container"></div>
    <pre>{{ process.components }}</pre>
    <configure-modal ref="configure_modal" @success="update_component" />
  </section>
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  success_message,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import BpmnModeler from "bpmn-js/lib/Modeler";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
import "bpmn-js/dist/assets/bpmn-js.css";
import "bpmn-js/dist/assets/diagram-js.css";
// import StartEventModal from "./components/start_event/Index.vue";
import ConfigureModal from "./components/configure_modal/Index.vue";

export default {
  name: "NgineComposerProcess",
  components: { ConfigureModal },
  data() {
    return {
      process: {},
      modeler: null,
    };
  },
  methods: {
    format_currency,
    save() {
      let v = this;
      v.modeler
        .saveXML({ format: true })
        .then((xml) => {
          let currentDefinitions = v.modeler.getDefinitions();
          let collaboration = currentDefinitions.rootElements.find(
            (e) => e.$type == "bpmn:Collaboration"
          );
          let process_name = collaboration.participants.find((p) => p).name;

          // let process = currentDefinitions.rootElements.find(
          //   (e) => e.$type == "bpmn:Process"
          // );
          // let roles = process.laneSets
          //   .find((e) => e.$type == "bpmn:LaneSet")
          //   .lanes.map((l) => l.name);
          // console.log("roles", roles);

          v.$root.loader(true);
          post("/ngine/composer/process/compose", {
            uuid: v.$route.params.id,
            xml: xml.xml,
            name: process_name,
            components: v.process.components,
          })
            .then((response) => {
              success_message(v.$t("process saved"));
              v.process.name = process_name;
            })
            .catch((err) => {
              console.error("error saving process", err);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        })
        .catch((err) => {
          console.error("error saving process", err);
        });
    },
    confgure_element(element) {
      let v = this;
      v.$refs.configure_modal.show_modal(element);
    },
    update_component(data) {
      let v = this;
      let trgt = v.process.components.find((c) => c.id == data.id);
      if (trgt) {
        trgt.settings = data.settings;
      } else {
        v.process.components.push({ ...data });
      }

      if (data.name) {
        let modeling = v.modeler.get("modeling");
        const elementRegistry = v.modeler.get("elementRegistry");
        let trgt = elementRegistry.get(data.id);

        modeling.updateProperties(trgt, {
          name: data.name,
        });
      }
    },
    human_tasks() {
      let v = this;
      // console.log("human tasks", v.$route.params);
      v.$router.push({
        path: `/ngine/composer/human-tasks/${v.$route.params.id}`,
      });
    },
  },
  mounted() {
    let v = this;
    v.modeler = new BpmnModeler({
      container: v.$refs.process_container,
    });

    var eventBus = v.modeler.get("eventBus");
    eventBus.on("element.dblclick", function (event) {
      let component = v.process.components.find(
        (c) => c.id == event.element.id
      );
      let elmnt = event.element.businessObject;
      elmnt.settings = component ? component.settings : {};
      // console.log("elmnt", elmnt);
      let cpy = JSON.parse(JSON.stringify(elmnt));
      v.confgure_element(cpy);
    });

    // eventBus.on("element.click", function (event, element) {
    //   console.log(element.element);
    // });

    eventBus.on("shape.added", function (event) {
      let businessObject = event.element.businessObject;
      let trgt = v.process.components.find((c) => c.id == businessObject.id);
      if (!trgt) v.process.components.push(businessObject);
    });
    // eventBus.on("shape.changed", function (event) {
    //   console.log("shape changed", event);
    // });
    eventBus.on("shape.removed", function (event) {
      let businessObject = event.element.businessObject;
      let trgt = v.process.components.find((c) => c.id == businessObject.id);
      if (trgt)
        v.process.components = v.process.components.filter(
          (c) => c.id != trgt.id
        );
    });

    v.$root.loader(true);
    get("/ngine/composer/process", { uuid: v.$route.params.id })
      .then((response) => {
        let components = [...response.components] || [];
        // console.log("components", components);
        response.components = [];

        v.process = response;
        if (v.process.xml) {
          v.modeler
            .importXML(v.process.xml)
            .then(() => {
              setTimeout(() => {
                // console.log("imported xml, set components", components);
                components.forEach((c) => {
                  let trgt = v.process.components.find((e) => e.id == c.id);
                  if (trgt) trgt.settings = c.settings;
                });
                let svgs = window.jQuery(".editor-container svg:last");
                svgs.addClass("svgprocess");
              }, 500);
            })
            .catch((err) => {
              console.error("error rendering process", err);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        } else {
          get("/ngine/composer/process/default", {})
            .then((response) => {
              response = response.replace(
                /PROCESS_NAME/g,
                v.process.name || v.$t("process")
              );
              v.modeler
                .importXML(response)
                .then(() => {
                  setTimeout(() => {
                    let svgs = window.jQuery(".editor-container svg:last");
                    svgs.addClass("svgprocess");
                  }, 500);
                })
                .catch((err) => {
                  error_message(err);
                })
                .finally(() => {
                  v.$root.loader(false);
                });
            })
            .catch((error) => {
              error_message(error);
            });
        }
      })
      .catch((error) => {
        error_message(error);
      });
  },
  created() {},
};
</script>

<style>
.editor-container {
  width: 100%;
  height: 600px;
  /* background-color: rgb(198, 198, 198); */
  background-color: rgb(109, 109, 109);
}

.svgprocess {
  width: 100% !important;
  height: 100% !important;
}

.djs-palette {
  border: 1px solid black;
}
</style>
